import axios from "axios"
import { BastaError } from "@/errors"
import { db, TIMESTAMP } from "./firebase"
import Vue from "vue"

const DEVICE_PAIRING_URL = process.env.VUE_APP_DEVICE_PAIRING_URL
const DEVICE_TOKEN_URL = process.env.VUE_APP_DEVICE_TOKEN_URL

export default {
  pairingCodeRef(code) {
    return db.ref("pairing").child(code)
  },

  onPairingMatchPromise(code) {
    return new Promise((resolve, reject) => {
      this.pairingCodeRef(code).on(
        "value",
        snapshot => {
          const pairing = snapshot.val()
          if (pairing !== null) {
            resolve(pairing)
            this.pairingCodeRef(code).off("value")
          }
        },
        error => {
          reject(error)
          this.pairingCodeRef(code).off("value")
        }
      )
    })
  },

  addPairing(projectId, code) {
    return this.pairingCodeRef(code).set({
      projectId,
      updatedAt: TIMESTAMP
    })
  },

  pairingExists(code) {
    return new Promise(resolve => {
      this.pairingCodeRef(code).once(
        "value",
        snapshot => resolve(snapshot.val() !== null),
        error => {
          Vue.$logger.error(error.message, error)
          resolve(false)
        }
      )
    })
  },

  async pairDevice(deviceId, code) {
    try {
      const response = await axios.get(DEVICE_PAIRING_URL, {
        params: {
          deviceId,
          code
        }
      })
      return response.data.projectId
    } catch (e) {
      switch ((e && e.response && e.response.status) || 0) {
        case 0:
          throw new BastaError("offline", "Connection problem.")
        case 400:
        case 401:
          throw new BastaError("not-paired", "Device is not paired.")
        default:
          throw e
      }
    }
  },

  async getToken(deviceId, code, projectId) {
    try {
      const response = await axios.get(DEVICE_TOKEN_URL, {
        params: {
          deviceId,
          code,
          projectId
        }
      })
      return response.data.token
    } catch (e) {
      switch ((e && e.response && e.response.status) || 0) {
        case 0:
          throw new BastaError("offline", "Connection problem.")
        case 400:
        case 401:
          throw new BastaError("not-paired", "Device is not paired.")
        default:
          throw e
      }
    }
  }
}
